"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useMount(callback) {
    var _a = (0, react_1.useState)(false), mounted = _a[0], setMounted = _a[1];
    (0, react_1.useEffect)(function () {
        setMounted(true);
        var cleanup;
        if (typeof callback === "function") {
            cleanup = callback();
        }
        return function () {
            setMounted(false);
            if (typeof cleanup === "function") {
                cleanup();
            }
        };
    }, []);
    return mounted;
}
exports.default = useMount;
//# sourceMappingURL=index.js.map